import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { getListingRequest } from '../listingRequestsEndpoints'
import { listingRequestKeys } from '../listingRequestsQueryKeys'

export function useListingRequestDetailQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => listingRequestKeys.detail(toValue(id)),
    queryFn: () => getListingRequest(toValue(id)),
    enabled: () => !!toValue(id),
  })
}
